import c from "../common";

export default {
    Name: "Name",
    CollectedVsTotal: "Collected/Total",
    EventTime: "Collection Period",
    Record: "Record",
    Edit: "Edit",
    ConfirmCancel: "Confirm cancel?",
    Yes: "Yes",
    No: "No",
    Cancel: "Cancel",
    EffectivePeriod: "Expiry Date",
    CollectAmount: "Collected Quantity",
    Left: "Qty left",
    Probability: "Probability(change by remaining qty)",
    QtyPerCollection: "Qty Per Collection",
    Delete: "Delete",
    NameCannotBeNull: "Field Name cannot be empty",
    PleaseChooseCollectTime: "Please select a pick-up period",
    SelectVoucher: "Please use voucher",
    QtyCannotBeZero: "Reserved Quantity for Reward Event cannot be 0",
    QtyCannotBeNull: "Please specify qty per collection",
    PromoteCodeAreadyExist: "Promo code already exists",
    ErrorOccured: "Error occurred",
    CreatedSuccessfully: "Created successfully",
    RewardEventNotFound: "Reward Event not found",
    changeSuccessfully: "Changed successfully",
    RewardEvent: "Reward Event",
    Create: "Create",
    Confirm: c.Confirm.en,
    Submit: "Submit",
    Voucher: c.voucher.en.uppercase,
    OnGoing: c.OnGoing.en,
    Pending: c.Pending.en,
    Expired: c.Expired.en,
    Cancelled: c.Cancelled.en,
    Regulation1: "Rules: Within the collection period, each phone can only collect once, and a gift will be sent randomly",
    GiftContent: "Gift",
    CollectPeriod: "Collect Period:",
    To: "to",
    VoucherName: "Voucher name",
    Value: "Value: $",
    NoSuchVoucher: "No Voucher",
    UpperBound: "UpperBound:",
    LowerBound: "LowerBound:",
    MustBeInteger: "Must be integer",
    ExceedUpperOrLower: "Exceed upper or lower bound",
    Translation1: "collection record",
    PromoteCode: "Promotion Code",
    PromoteCodeCannotBeNull: "Promotion Code cannot be empty",
    PromoteCodeLengthMustBe6: "Promotion Code length must be 6",
    PromoteCodeContent: "Promotion Code can only contain numbers and characters",
    WhenEventNotYetStart: "The following content can only be modified before the event start",
    BriefIntro: "Description",
    Optional: "Optional",
    PromoteCodeTranslation1: "Promotion Code (length of 6, can only contain upper letter and numbers)",
    SelectThatVoucher: "Select Voucher",
    ReChoose: "choose again",
    edit: "edit",
    availQty: "available qty",
    Collected: "Collected Pack",
    Rule: "Rule",
    RuleDescription1: "Each phone number can only collect once",
    RuleDescription2: "Collect",
    RuleDescription3: "voucher each time",
    JoinedShop: "Joined Shop",
    None: "none",
    Voucher: c.voucher.en.uppercase,
    RewardEventName: "Reward Event Name",
    Reward: "Reward",
    //
    text1: "The minimum number of points is 1",
    text2: "You must choose to gift points or voucher",
    text3: "Modifying this information will reset the form",
    text4: "Gift point",
    text5: "yes",
    text6: "no",
    text7: "If you want to gift points, you must have a estamp plan within the point earning period",
    text8: "create estamp plan",
    text9: "number of points",
    text10: "point earning period",
    text11: "Add voucher",
    text12: "Promotion code expire: {{end}}",
    text13: "Only show vouchers that expire on or after {{end}}",
    text14: "Point",
    text15: "Left",
    text16: "Name/Expiry",
    text17: "Gift pack cannot be empty",
};
